import { render, staticRenderFns } from "./ResearchOutputResearchStatement.vue?vue&type=template&id=04660eeb&"
import script from "./ResearchOutputResearchStatement.vue?vue&type=script&lang=js&"
export * from "./ResearchOutputResearchStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports